export default "__VITE_ASSET__DavZknQ5__"